import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { theme } from 'core/Theming/theme';

export const cellPrepared = (e: DataGridTypes.CellPreparedEvent) => {
  // TODO: refactor (code resposible for coloring cells)
  if (e.rowType === 'data') {
    let color = theme.palette.background.default;
    if (e.data?.slaBreach === 1) {
      color = theme.palette.reports.pink;
    }
    if (e.data?.slaBreach === 0) {
      color = theme.palette.reports.green;
    }
    e.cellElement.style.cssText = `background-color: ${color}`;
  }

  if (e.rowType === 'group' && e.column?.dataField === 'startDTG') {
    const percentString = String(e.row.data.aggregates[0] ?? '0.00%');
    const normalizedPercent = percentString
      .replace('%', '')
      .trim()
      .replace(',', '.');
    const numericSummaryValue = Number(normalizedPercent);

    const summaryElement = e.cellElement.querySelector(
      '.dx-datagrid-summary-item'
    ) as HTMLElement | null;
    if (summaryElement) {
      if (numericSummaryValue > 85) {
        summaryElement.style.cssText = `background-color: ${theme.palette.reports.green}; padding: 5px;`;
        return;
      }
      if (numericSummaryValue > 75 && numericSummaryValue <= 85) {
        summaryElement.style.cssText = `background-color: ${theme.palette.reports.orange1}; padding: 5px;`;
        return;
      }
      summaryElement.style.cssText = `background-color: ${theme.palette.reports.pink}; padding: 5px;`;
    }
  }
};
